// src/utils/formatCurrency.js

import { APP_CONSTANTS } from "../core/constants";

/**
 * Formats a number into a currency string.
 * Defaults to app currency (ZAR).
 *
 * @param {number|string} value
 * @param {string} currency
 * @param {string} locale
 * @returns {string}
 */
export const formatCurrency = (
  value,
  currency = APP_CONSTANTS.CURRENCY,
  locale = "en-ZA"
) => {
  const amount = typeof value === "number"
    ? value
    : parseFloat(value);

  if (isNaN(amount)) return "R0.00";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
};